// =====================================================
// Cannabis 30g Purchase Limit
// =====================================================

(function () {
  const MAX_GRAMS = 30;

  async function getCart() {
    const response = await fetch('/cart.js');
    return await response.json();
  }

  async function getCartTotalGrams() {
    const cart = await getCart();

    let total = 0;

    cart.items.forEach((item) => {
      const grams = Number(
        item.properties?._cannabis_weight || 0
      );

      total += grams * item.quantity;
    });

    return total;
  }

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const url = args[0]?.toString() || '';

    // ==========================================
    // Product Page / Add To Cart Protection
    // ==========================================
    if (url.includes('/cart/add.js')) {
      try {
        const options = args[1];

        let weight = 0;
        let quantity = 1;

        if (options?.body instanceof FormData) {
  quantity = Number(
    options.body.get('quantity') || 1
  );

  const variantId = Number(
    options.body.get('id')
  );
  
  console.log('Quick Add Variant:', variantId);

  weight =
    Number(
      options.body.get('properties[_cannabis_weight]')
    ) ||
    Number(
      window.cannabisGrams?.[variantId]
    ) ||
    0;

    console.log('Weight Found:', weight);
}

        const currentTotal = await getCartTotalGrams();

        const proposedTotal =
          currentTotal + weight * quantity;

        console.log({
          currentTotal,
          weight,
          quantity,
          proposedTotal,
        });

        if (proposedTotal > MAX_GRAMS) {
          alert(
            `🚫 Cannabis purchase limit exceeded.

Maximum allowed: ${MAX_GRAMS}g
Current cart: ${currentTotal}g
Attempted total: ${proposedTotal}g`
          );

          throw new Error('Cannabis limit exceeded');
        }
      } catch (error) {
        console.warn(error);
        return Promise.reject(error);
      }
    }

    // ==========================================
    // Cart Quantity Change Protection
    // ==========================================
    if (url.includes('/cart/change')) {
      try {
        const options = args[1];

        if (
          options?.body &&
          typeof options.body === 'string'
        ) {
          const payload = JSON.parse(options.body);

          const cart = await getCart();

          const lineIndex = payload.line - 1;
          const newQuantity = Number(payload.quantity);

          const changedItem = cart.items[lineIndex];

          if (!changedItem) {
            return originalFetch.apply(this, args);
          }

          let total = 0;

          cart.items.forEach((item, index) => {
            const weight = Number(
              item.properties?._cannabis_weight || 0
            );

            if (index === lineIndex) {
              total += weight * newQuantity;
            } else {
              total += weight * item.quantity;
            }
          });

          console.log({
            currentTotal: await getCartTotalGrams(),
            weight: Number(
              changedItem.properties?._cannabis_weight || 0
            ),
            quantity: newQuantity,
            proposedTotal: total
          });

          if (total > MAX_GRAMS) {
            alert(
              `🚫 Cannabis purchase limit exceeded.\n\nMaximum allowed: ${MAX_GRAMS}g\nAttempted total: ${total}g`
            );

            setTimeout(() => {
              fetch('/cart.js')
                .then(r => r.json())
                .then(cart => {
                  console.log('Actual cart:', cart);
                  location.reload();
                });
            }, 100);

            return Promise.reject(
              new Error('Cannabis limit exceeded')
            );
          }
        }
      } catch (error) {
        console.warn(error);
        return Promise.reject(error);
      }
    }

    return originalFetch.apply(this, args);
  };

  console.log('Cannabis 30g limiter loaded');
})();